import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';

export const StepperWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 0;

    svg {
        max-width: 100%;
        max-height: 54px;
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    > div[style*='display: grid'] {
        gap: 4px 12px !important;
        margin-top: 4px !important;
    }

    p {
        margin: 0;
        line-height: 1.3;
    }

    > .MuiTextField-root,
    > div {
        margin-top: 0 !important;
    }

    .MuiInputLabel-root,
    .MuiTypography-body1 {
        color: #64748b;
        font-size: 13px;
        font-weight: 500;
        margin-left: 0;
        margin-bottom: 0;
        line-height: 1.2;
    }

    .MuiOutlinedInput-root {
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
        transition:
            box-shadow 0.2s ease,
            border-color 0.2s ease,
            transform 0.2s ease;
    }

    .MuiOutlinedInput-root:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    }

    .MuiOutlinedInput-notchedOutline {
        border-color: rgba(148, 163, 184, 0.28);
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
        border-color: rgba(131, 83, 226, 0.32);
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: #8353e2;
    }

    .MuiInputBase-input {
        padding: 11px 12px;
        font-size: 14px;
    }

    .MuiSelect-select {
        padding: 11px 12px;
    }

    .MuiIconButton-root {
        padding: 2px;
    }

    .ql-toolbar.ql-snow {
        border-color: rgba(148, 163, 184, 0.24);
        border-radius: 16px 16px 0 0;
        background: rgba(255, 255, 255, 0.88);
    }

    .ql-container.ql-snow {
        min-height: 360px;
        border-color: rgba(148, 163, 184, 0.24);
        border-radius: 0 0 16px 16px;
        background: rgba(255, 255, 255, 0.9);
    }
`;

export const SaveButton = styled.button`
    width: 126px;
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: '#8353E2FF' })}
    background: white; /* white */
    opacity: 1;
    border: 1px solid #8353e2ff; /* border-s */
    border-radius: 3px;
    &:hover {
        color: #ffffffff; /* white */
        background: #6025d8ff; /* secondary-600 */
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    gap: 24px;
`;

export const LoadingStep = styled.div<{ active?: boolean; done?: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    border-radius: 8px;
    width: 100%;
    max-width: 360px;
    background: ${({ active, done }) => (done ? '#f0faf4' : active ? '#f5f0ff' : 'transparent')};
    border: 1px solid ${({ active, done }) => (done ? '#4caf50' : active ? '#8353e2' : '#e0e0e0')};
    transition: all 0.3s ease;
    opacity: ${({ active, done }) => (active || done ? 1 : 0.4)};
`;

export const StepIcon = styled.div<{ done?: boolean }>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ done }) => (done ? '#4caf50' : '#8353e2')};
    color: white;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    gap: 16px;
    text-align: center;
    padding: 24px;
`;
